module.exports = lincd._modules['lincd_rest_api'];